var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    {
      on: {
        click: _vm.rightClickDisabled,
        contextmenu: function($event) {
          $event.preventDefault()
        }
      }
    },
    [
      _c("v-progress-linear", {
        attrs: {
          active:
            _vm.$store.state.loading || _vm.$store.state.progressbarActive,
          indeterminate:
            _vm.$store.state.loading || _vm.$store.state.progressbarActive,
          top: true,
          height: 5,
          rounded: true,
          value: 0,
          color: "indigo darken-2"
        }
      }),
      _vm.$store.state.loading
        ? _c("div", { attrs: { id: "loading" } }, [_c("div")])
        : _vm._e(),
      _c("Menu", { ref: "menu" }),
      _c(
        "v-content",
        { staticClass: "mb-12" },
        [_c("v-container", { attrs: { fluid: "" } }, [_c("router-view")], 1)],
        1
      ),
      _c(
        "v-footer",
        { staticClass: "bgheader", attrs: { fixed: "" } },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c("v-col", { attrs: { cols: "10", sm: "9" } }),
              _c(
                "v-col",
                {
                  staticClass: "d-flex justify-center sm:justify-end",
                  attrs: { cols: "12", sm: "3" }
                },
                [
                  _c("v-img", {
                    staticClass: "ml-4 logoelection",
                    attrs: {
                      contain: "",
                      "max-height": "20px",
                      src: require("@/assets/img/logoEleicoes.png")
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }